module.exports = __webpack_public_path__ + "img/Footer-Amex.2ed864f.svg";